import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { AppContext } from '../AppContext';

const withRoleAccess = (WrappedComponent, allowedRoles) => {

    return props => {

        const { currentUser } = useContext(AppContext);

        if (currentUser && currentUser.roles) {
            const hasAccess = currentUser.roles.some(role => allowedRoles.includes(role.role));
            if (!hasAccess) {
                return <Redirect to="/unauthorized" />;
            }
        }

        return <WrappedComponent {...props} />;
    };
};

export default withRoleAccess;